<script setup lang="ts"></script>

<template>
  <div class="main-container d-flex flex-1 relative items-center">
    <div class="d-flex flex-1 flex-col items-center gap-[24px]">
      <img src="/maintenance-icon.png" class="w-[72px]" alt="fence-icon" />

      <div class="flex flex-col items-center gap-[48px] flex-1">
        <h1 class="text-6xl text-center">Wir sind gleich wieder da</h1>
        <p class="text-2xl text-center">
          Unsere Anwendung e:lmo ist momentan nicht erreichbar. Wir arbeiten an einer Lösung. Wir
          benachrichtigen Sie per E-Mail, sobald e:lmo wieder erreichbar ist.
        </p>
      </div>
    </div>

    <VImg class="absolute bottom-0 inset-x-0 m-auto" src="/elmo-logo.svg" width="180" />
  </div>
</template>

<style lang="scss" scoped>
.main-container {
  margin-inline: 30px;
  height: 100vh;
}

@media only screen and (width > 600px) {
  .main-container {
    margin-inline: 175px;
  }
}

@media only screen and (width >= 1440px) {
  .main-container {
    margin-inline: 415px;
  }
}
</style>
